import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FamilyGallery from "../pages/portfolio/family/page";
import WeddingGallery from "../pages/portfolio/wedding/page";
import PortraitGallery from "../pages/portfolio/portrait/page";
import EventsGallery from "../pages/portfolio/events/page";
import WajimaNuriProject from "../pages/portfolio/wajima-nuri/page";
import NotoRecoveryProject from "../pages/portfolio/noto-recovery/page";
import CommercialGallery from "../pages/portfolio/commercial/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/portfolio/family",
    element: <FamilyGallery />,
  },
  {
    path: "/portfolio/wedding",
    element: <WeddingGallery />,
  },
  {
    path: "/portfolio/portrait",
    element: <PortraitGallery />,
  },
  {
    path: "/portfolio/events",
    element: <EventsGallery />,
  },
  {
    path: "/portfolio/wajima-nuri",
    element: <WajimaNuriProject />,
  },
  {
    path: "/portfolio/noto-recovery",
    element: <NotoRecoveryProject />,
  },
  {
    path: "/portfolio/commercial",
    element: <CommercialGallery />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;